import { render, staticRenderFns } from "./ModalVincularNivelSelo.vue?vue&type=template&id=12eed3d3&scoped=true"
import script from "./ModalVincularNivelSelo.vue?vue&type=script&lang=js"
export * from "./ModalVincularNivelSelo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12eed3d3",
  null
  
)

export default component.exports